import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import BiButton from '../../biLogger/Components/BiButton';
import BiLink from '../../biLogger/Components/BiLink';
import s from './PlainButtonOrLink.scss';
var PlainButtonOrLink = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    var classNames = classnames(s['button'], className);
    var href = rest.href;
    return href ? (React.createElement(BiLink, __assign({ className: classNames }, rest))) : (React.createElement(BiButton, __assign({ className: classNames }, rest)));
};
PlainButtonOrLink.displayName = 'PlainButtonOrLink';
export default PlainButtonOrLink;
//# sourceMappingURL=PlainButtonOrLink.js.map